import React, { useState } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";

import { Image } from "react-bootstrap";

import logoUrl from "../../Assets/images/logo.png";

import {
  logoutAction,
  toggleMenuAction,
} from "../../Store/Actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModal from "./Models/ConfirmModal";
import { trackEvent } from "../../utils/analytics";

const SideBarMenu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuState = useSelector((state) => state.auth.isMenuOpen);
  const [logoutConfirm, setLogoutConfirm] = useState(false);

  const askLogout = () => setLogoutConfirm(true);

  const performLogout = () => {
    trackEvent("web_logout", { role: "admin" });
    setLogoutConfirm(false);
    logoutAction(dispatch);
    navigate("/");
  };

  const slideMenu = () => {
    toggleMenuAction(!menuState, dispatch);
  };

  const menuItems = [
    {
      icon: "fas fa-store",
      title: "Spots",
      link: "/admin/spots",
      submenu: false,
    },
    {
      icon: "fas fa-car",
      title: "Vehicles",
      link: "/admin/vehicles",
      submenu: false,
    },
    {
      icon: "fas fa-ticket",
      title: "Bookings",
      link: "/admin/bookings",
      submenu: false,
    },
    {
      icon: "fas fa-tags",
      title: "Payments",
      link: "/admin/payments",
      submenu: false,
    },
    {
      icon: "fas fa-users",
      title: "Users",
      link: "/admin/users",
      submenu: false,
    },
    {
      icon: "fas fa-mobile-alt",
      title: "App Versions",
      link: "/admin/app-versions",
      submenu: false,
    },
    // {
    //   icon: "fas fa-sliders-h",
    //   title: "Settings",
    //   link: "/admin/settings",
    // },
  ];

  const listMenuItems = (menuItems) => {
    const activePage = location.pathname;

    return menuItems.map((item, index) => {
      let ClassName = activePage === item.link ? "active" : "";

      if (item.submenu) {
        item.submenu.map((subitem) => {
          if (activePage === subitem.link) ClassName = "active";
          return null;
        });
      }

      return (
        <li key={`parent_menu_${index}`} className={ClassName}>
          <NavLink exact to={item.link}>
            <i className={`menu-icon ${item.icon}`} />
            <span className="menu-title">{item.title}</span>
          </NavLink>
          {item.submenu && (
            <React.Fragment>
              <ul className="sub-menu">
                {item.submenu.map((subitem, index) => {
                  const subClassActive =
                    activePage === subitem.link ? "active" : "";
                  return (
                    <li key={`sub_menu_${index}`} className={subClassActive}>
                      <NavLink exact to={subitem.link}>
                        {subitem.title}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          )}

          {item.submenu && (
            <span
              className="down-arrow"
              onClick={(e) => {
                // this.toggleSubMenu(e);
              }}
            >
              <i className="fas fa-angle-right" />
            </span>
          )}
        </li>
      );
    });
  };

  const toggleSubMenu = (e) => {
    const parentLi = e.currentTarget.parentNode.className;
    if (parentLi === "") {
      e.currentTarget.parentNode.classList.add("active");
    } else {
      e.currentTarget.parentNode.classList.remove("active");
    }
  };

  return (
    <div className="sidebar-wrapper">
      <div className="logo-wrapper">
        <Link to="/admin">
          <Image src={logoUrl} alt="Spotie Parking" />
        </Link>
        <div className="menu-icon" onClick={() => slideMenu()}>
          <span className="bars" />
          <span className="bars" />
          <span className="bars" />
        </div>
      </div>
      <div className="sidebar-menu">
        <ul>
          {listMenuItems(menuItems)}
          <li>
            <span className="link" onClick={() => askLogout()}>
              <i className="menu-icon fas fa-sign-out-alt" />
              <span className="menu-title">Logout</span>
            </span>
          </li>
        </ul>
      </div>

      <ConfirmModal
        show={logoutConfirm}
        title="Logout"
        message="Are you sure want to logout?"
        confirmLabel="Yes, logout"
        cancelLabel="No"
        onClose={() => setLogoutConfirm(false)}
        onConfirm={performLogout}
      />
    </div>
  );
};

export default SideBarMenu;
